<template>
  <div class="ticketAgain">
    <div class="top">
      <trip @way="way" :travelMode="ticketList.travelMode" :seatName="ticketList.seatName" />
    </div>
    <div class="bottom">
      <div class="depart">
        <label for=""> 
          <span>选择出发日期:</span>
           <el-date-picker
                type="dates"
                 @change="changeTime"
                v-model="value1"
                placeholder="选择一个或多个日期">
              </el-date-picker>
        </label>
        <label for="">
          <span>出发地:</span>
          <input type="text" placeholder="请输入出发地" v-model="ticketList.departurePlace">
        </label>
        <label for="">
          <span>目的地:</span>
          <input type="text" placeholder="请输入目的地" v-model="ticketList.destinationPlace">
        </label>
        <label for="">
          <span>车次:</span>
          <input type="text" placeholder="请输入车次" v-model="ticketList.trainNumber">
        </label>
        <p class="notice">注：不输入表示无要求</p>
      </div>
      <button  @click="next">下一步</button>
    </div>

  </div>
</template>

<script>
import Trip from '../../../components/Courier/Trip'
import {formatDate} from '../../../utils/date'
import {reqTicketOrderDetail} from '../../../api'
export default {
  data() {
    return{
      ticketList: {},
      value1: []

    }
  },
  mounted() {
    const {id} = this.$route.query
    reqTicketOrderDetail(id).then(res => {
      console.log(res)
      if(res.code === 200) {
        this.ticketList = res.data.bussData
        console.log(this.ticketList.seatName.split(','))
        let timeArr = res.data.bussData.departureDate.split(',')
        console.log("时间",timeArr)
        timeArr.forEach(item=>{
          this.value1.push(new Date(item))
        })
        // this.value1.push(timeArr[0])
        // this.value1.push(timeArr[timeArr.length-1])
      }
    })
  },
  methods: {
    // 获取出行方式
    way(refereeArr, trip) {
      console.log('第一次选择',refereeArr)
      this.ticketList.travelMode = trip
      this.ticketList.seatType = refereeArr
    },
    next () {
      const {travelMode, seatType, departureDate, departurePlace, destinationPlace} = this.ticketList
    if(JSON.stringify(seatType) === '[]'|| typeof seatType == "string" ){
        this.$message({
          message: '请选择出行方式',
          type: 'error'
        })
      } else if(!departureDate){
        this.$message({
          message: '请选择出发日期',
          type: 'error'
        })
      } else if(!departurePlace){
        this.$message({
          message: '请填入出发地',
          type: 'error'
        })
      } else if(!destinationPlace){
        this.$message({
          message: '请填入目的地',
          type: 'error'
        })
      } else {
        console.log("数据",this.ticketList.seatType)
        this.$store.dispatch('getTicketInfo', this.ticketList)
        this.$router.push({name: 'TicketOrder'})

      }
    },
    // 获取时间
    changeTime(val) {
       let arrDate=[]
        val.forEach(item=>{
          arrDate.push(formatDate(new Date(item), 'yyyy-MM-dd ')+'00:00:00')
        })
      this.ticketList.departureDate = arrDate.join(',')
      return
      let date1 = new Date(val[0])
      let time1 = formatDate(date1, 'yyyy-MM-dd ')
      let date2 = new Date(val[1])
      let time2 = formatDate(date2, 'yyyy-MM-dd ')
      this.getDayAll(time1, time2)
    },
    // 按填查询
    getDayAll(begin, end) {
      Date.prototype.format = function () {
        var s = '';
        s += this.getFullYear() + '-';          // 获取年份。
        s += (this.getMonth() + 1) + "-";         // 获取月份。
        s += this.getDate();                 // 获取日。
        return (s + ' 00:00:00');                          // 返回日期。
      };
      var dateAllArr = new Array();
      var ab = begin.split("-");
      var ae = end.split("-");
      var db = new Date();
      db.setUTCFullYear(ab[0], ab[1] - 1, ab[2]);
      var de = new Date();
      de.setUTCFullYear(ae[0], ae[1] - 1, ae[2]);
      var unixDb = db.getTime();
      var unixDe = de.getTime();
      for (var k = unixDb; k <= unixDe;) {
        dateAllArr.push((new Date(parseInt(k))).format().toString());
        k = k + 24 * 60 * 60 * 1000;
      }
      // console.log(this.orgOptions.xAxis.data);
      console.log();
      this.ticketList.departureDate = dateAllArr.join(',')
    },
  },
  components: {
    Trip
  }
}
</script>

<style scoped lang="less" type="text/less">
.ticketAgain{
  padding-top:60px;
  .bottom{
    .depart{
      label{
        display: flex;
        margin-bottom: 20px;
        &:last-of-type{
          margin-bottom: 11px;
        }
        span{
          display: block;
          width: 90px;
          text-align: right;
          line-height: 40px;
          margin-right: 12px;
        }
        input{
          width: 340px;
          height: 40px;
          text-indent: 13px;
          box-sizing: border-box;
          border:1px solid #e1e1e1;
          border-radius: 4px;
          &::-webkit-input-placeholder{
            color:#c0c4cc;
          }
        }
      }
      .notice{
        color:#999;
        text-indent: 102px;
      }

    }
    button{
      width: 332px;
      height: 48px;
      margin:48px 0 0 53px;
      border:none;
      border-radius: 24px;
      background: #61aee6;
      color:#fff;
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Person/Children/TicketAgain.vue